import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ModuleGetAllService } from '../../services';

export const fetchModuleGetAll = createAsyncThunk(
    'moduleGetAll/fetchModuleGetAll',
    async () => {
        const response = await ModuleGetAllService()
        return response.result
    }
);

const moduleGetAllSlice = createSlice({
    name: 'moduleGetAll',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchModuleGetAll.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchModuleGetAll.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchModuleGetAll.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default moduleGetAllSlice.reducer;
